// extracted by mini-css-extract-plugin
export var eyebrow = "_gg-3";
export var heroImage = "_gg-4";
export var main = "_gg-2";
export var modal = "_gg-0";
export var shell = "_gg-1";